import TYPES from '@/modules/shared/types';

// Domain
import { AllianzEarningsReportRepository } from '../../domain/repository';
import { AllianzEarningsReportEntity } from '../../domain/entities/allianz-earnings-report-entity';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class AllianzEarningsReportHttpRepository
implements AllianzEarningsReportRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/allianz/allianz-earnings-report/{CUSTOMER_ID}/`;

  execute(customer_id: string): Promise<Array<AllianzEarningsReportEntity>> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint.replace('{CUSTOMER_ID}', customer_id))
        .then((response) => {
          response.json()
            .then(({ data, success, message }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(message));
              }
            });
        })
        .catch(reject);
    });
  }
}
